/* eslint-disable react/display-name */
// lib/sanity.js
import {
    createCurrentUserHook,
    createImageUrlBuilder,
    createPortableTextComponent,
    createPreviewSubscriptionHook
} from 'next-sanity'
import React from 'react'
import ReactPlayer from 'react-player'
import { config } from './config'

/**
 * Set up a helper function for generating Image URLs with only the asset reference data in your documents.
 * Read more: https://www.sanity.io/docs/image-url
 **/
export const urlFor = (source) => createImageUrlBuilder(config).image(source)

// Set up the live preview subscription hook
export const usePreviewSubscription = createPreviewSubscriptionHook(config)

// Set up Portable Text serialization
export const PortableText = createPortableTextComponent({
    ...config,
    // Serializers passed to @sanity/block-content-to-react
    // (https://github.com/sanity-io/block-content-to-react)
    serializers: {
        types: {
            image: (props) => {
                return props.node.imageLink ? (
                    <a href={props.node.imageLink}>
                        <figure>
                            <img src={urlFor(props.node.asset).url()} />
                        </figure>
                    </a>
                ) : (
                    <figure>
                        <img src={urlFor(props.node.asset).url()} />
                    </figure>
                )
            },
            inlineImg: (props) => {
                return <img src={props.node.url} />
            },
            youtube: (props) => {
                return (
                    <div className="overflow-hidden relative max-w-full py-5">
                        <ReactPlayer
                            className="max-w-full mx-auto"
                            url={props.node.url}
                        />
                    </div>
                )
            },
            html: (props) => {
                return <div dangerouslySetInnerHTML={{ __html: props.node.html }}></div>
            }
        }
    }
})

// Helper function for using the current logged in user account
export const useCurrentUser = createCurrentUserHook(config)
